import Image from 'next/image'
import { useSession } from 'next-auth/react'

import { useEffect, useState } from 'react'

import axios from 'axios'

import styles from './styles.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleMinus, faDiamond, faEye, faPencil, faPeopleGroup, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

import { motion } from 'framer-motion'

import { PulseLoader } from 'react-spinners'

import errorMsg from '../../../Functions/errorMsg'

import JobListing from '../JobListing/JobListing';
import EditJob from '../EditJob/EditJob';
import AppManager from './AppManager/AppManager'

export default function MyJobs({ setPendingRequest }) {

  const { data: session, status } = useSession();

  const [initialLoading, setInitialLoading] = useState(null);
  const [businessListings, setBusinessListings] = useState(null);

  useEffect(() => {
    if(initialLoading !== null) return;
    if(businessListings !== null) return;
    if(status === 'loading') return;
    if(!session) return;

    async function getMyListings() {
        setInitialLoading(true);
        setPendingRequest(true);

        const result = await axios.post(`${window.location.origin}/api/jobs/dashboard/getMyJobs`, {
          requestingUserID: session.user.token.id
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
            setPendingRequest(false);
        })

        if(result && result.status === 200) {
          const data = result.data;
          setBusinessListings(data);
          setPendingRequest(false);
        }

    }

    getMyListings();

  }, [session, status, initialLoading, businessListings])

  function isLoading() {
    if(status === 'loading') return true;
    if(initialLoading === false || initialLoading === null) return true;
    if(businessListings === null) return true;
    return false;
  }

  function refreshListings() {
    setBusinessListings(null);
    setInitialLoading(null);
  }

  const [viewListingData, setViewListingData] = useState(null);
  const [editListingData, setEditListingData] = useState(null);

  const [openAppManager, setOpenAppManager] = useState(null);

  return (
    <section id={styles.wrapper}>

      { openAppManager && <AppManager jobID={openAppManager} closeManager={() => setOpenAppManager(null)} refreshListings={refreshListings} /> }

      { viewListingData !== null && <JobListing listingID={viewListingData} closeListing={() => setViewListingData(null)} /> }
      { editListingData !== null && <EditJob listingID={editListingData.listingID} isFixing={editListingData.isFixing} refreshListings={refreshListings} closeEditor={() => setEditListingData(null)}  /> }

      { isLoading() === true && <section id={styles.loading}><PulseLoader size={30} color='#154734' /></section> }

      { isLoading() === false && (businessListings.length === 0 ?
        <div id={styles.noListings}>
          <h1>You have no job posts</h1>
        </div>
        :
        <section id={styles.container}>
          {
            businessListings.map((listing, index) => {
              return <ListingCard key={index} listing={listing} setViewListingData={setViewListingData} setEditListingData={setEditListingData} setOpenAppManager={setOpenAppManager} />
            })
          }
        </section>
      )}

  </section>
  )
}

const ListingCard = ({ listing, setViewListingData, setEditListingData, setOpenAppManager }) => {

  const listingID = listing._id;
  const employerLogo = listing.businessLogo;
  const employerName = listing.businessTitle;

  const positionTitle = listing.positionTitle;
  const positionType = listing.positionType;

  const totalApplicants = listing.applicants.length;

  const rateData = listing.rate;

  const formatCurrency = (rate) => {
    let parsedRate = parseFloat(rate).toFixed(2);
    if (parsedRate.endsWith('.00')) {
      parsedRate = parsedRate.slice(0, -3);
    }
    parsedRate = parsedRate.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
    return parsedRate;
  };
  
  const returnPayRate = () => {
    if (rateData.type === 'Hourly') {
      return `$${formatCurrency(rateData.rate)} / hr`;
    } else if (rateData.type === 'Salary') {
      return `$${formatCurrency(rateData.rate)} / yr`;
    }
  };

  function getReviewType() {
    var type = null;
    var fixed = false;

    listing.verdicts.forEach((verdict, index) => {
      if(verdict.fixed === true) {
        fixed = true;
      }
      if(listing.verdicts.length === (index + 1)) {
        if(verdict.fixed === false) {
          fixed = false;
        }
      }
    })

    if(listing.approved === false) {
      if(listing.verdicts.length > 0) {
        if(fixed === true) {
          type = 'Pending Approval'
        } else {
          type = 'Action Required'
        }
      } else {
        type = 'Pending Approval'
      }
    }

    return type;
  }

  const { displayString } = createdTimeStamp(listing.creationDate);

  
  return (
    <div className={styles.card}>
      { getReviewType() === 'Action Required' && <span id={styles.attention}> <FontAwesomeIcon icon={faTriangleExclamation} id={styles.icon} /> <h1>Action Required</h1> </span> }
      { getReviewType() === 'Pending Approval' && <span id={styles.pending}> <FontAwesomeIcon icon={faCircleMinus} id={styles.icon} /> <h1>Pending Approval</h1> </span> }

      <section>
        <div><Image sizes='auto auto' fill objectFit='cover' src={employerLogo} alt={employerLogo} /></div>
        <div>
          <h1>{returnPayRate()}</h1>
        </div>
      </section>

      <section>
        <h1>{positionTitle}</h1>
        <h2>{positionType}</h2>
        <h3>{employerName} • {displayString}</h3>
      </section>

      <section>
        { getReviewType() !== 'Pending Approval' && <motion.button onClick={() => setEditListingData({ isFixing: getReviewType() === 'Action Required' ? true : false, listingID: listingID })}>
            Edit<FontAwesomeIcon icon={faPencil} id={styles.icon} />
          </motion.button> }
        { getReviewType() === null && <motion.button onClick={() => setOpenAppManager(listingID)}><FontAwesomeIcon icon={faPeopleGroup} id={styles.icon} /> Apps <b>{totalApplicants}</b></motion.button> }
        { getReviewType() === null && <motion.button onClick={() => setViewListingData(listingID)}><FontAwesomeIcon icon={faEye} id={styles.icon} /></motion.button> }
      </section>

    </div>
  )
}

function createdTimeStamp(creationDate) {
  const units = [
      { label: 'month', ms: 30 * 24 * 60 * 60 * 1000 },
      { label: 'week', ms: 7 * 24 * 60 * 60 * 1000 },
      { label: 'day', ms: 24 * 60 * 60 * 1000 },
      { label: 'hour', ms: 60 * 60 * 1000 },
      { label: 'minute', ms: 60 * 1000 },
      { label: 'second', ms: 1000 }
  ];

  const now = new Date().getTime();
  const delta = now - new Date(creationDate).getTime();
  let result = { displayString: "just now", justPosted: delta < units[2].ms };

  for (let { label, ms } of units) {
      const value = Math.floor(delta / ms);
      if (value >= 1) {
          result.displayString = `${value} ${label}${value > 1 ? 's' : ''} ago`;
          break;
      }
  }

  return result;
}